export default __webpack_public_path__ + "static/media/seedx-titles-240x90.b77293d1.svg";